<!--
 * @Description: 
-->
<template>
  <el-form :inline="true" :model="filters" :size="size">
    <el-form-item class="select_btn">
      <el-select
        class="select_btn_style"
        v-model="filters.logType"
        placeholder="日志类型"
      >
        <el-option
          v-for="(item, i) in menuType"
          :key="i"
          :label="item.paramValue"
          :value="item.paramKey"
        ></el-option>
      </el-select>
    </el-form-item>
    <el-form-item class="m-l-14">
      <el-input
        prefix-icon="el-icon-search"
        v-model="filters.module"
        placeholder="模块名"
      ></el-input>
    </el-form-item>
    <el-form-item class="m-l-15">
      <el-input
        prefix-icon="el-icon-search"
        v-model="filters.operateDescription"
        placeholder="描述"
      ></el-input>
    </el-form-item>
    <el-form-item class="m-l-15">
      <el-input
        class="input_width_220"
        prefix-icon="el-icon-search"
        v-model="filters.operateParams"
        placeholder="日志参数，如被操作人姓名"
      ></el-input>
    </el-form-item>
    <el-form-item class="m-l-15">
      <el-input
        prefix-icon="el-icon-search"
        v-model="filters.userName"
        placeholder="操作人"
      ></el-input>
    </el-form-item>
    <el-form-item>
      <butn btntype="primary" title="查询" @click.native="initData"></butn>
      <butn :title="'重置'" @click.native="resetData" class="czButn"></butn>
    </el-form-item>
  </el-form>
</template>
<script>
import { getDataMap } from "@/api/sysParam";
import butn from "@/components/button/index";
import { SYSPARAM_STATUS } from "../../utils/constants";
export default {
  name: "search",
  components: {
    butn,
  },
  data() {
    return {
      size: "small",
      filters: undefined,
      options: [],
      statusOptions: SYSPARAM_STATUS,
      menuType: []
    };
  },
  created() {
    const emptyObj = Object.create(null);
    this.filters = emptyObj;
    this.getSysParam("LOG_TYPE");
  },
  methods: {
    // 获取数据字典
    getSysParam(param) {
      getDataMap(param).then(res => {
        if (!res || res.code != 0) return;
        res.data.splice(0, 0, {
          paramKey: "",
          paramValue: "全部"
        });
        this.menuType = res.data;
      });
    },
    initData() {
      //查询
      this.$emit("search", { ...this.filters, t: new Date().getTime() });
    },
    resetData() {
      //重置
      this.filters = {};
      this.$emit("search", { t: new Date().getTime() });
    },
  },
};
</script>
